import React from "react";

import { ReferenceInput, AutocompleteInput, BooleanInput } from "react-admin";

const invoiceExportFilters = [
  <ReferenceInput
    source="customerId"
    reference="Customer"
    sort={{ field: "name", order: "ASC" }}
    filterToQuery={(searchText: any) => ({
      q: searchText,
    })}
    alwaysOn
  >
    <AutocompleteInput optionText="name" emptyText="- alle -" />
  </ReferenceInput>,
  <BooleanInput source="onlyErrors" alwaysOn />,
  <BooleanInput source="onlyFailed" alwaysOn />,
];

export default invoiceExportFilters;
